import { useFeatureFlagPayload } from 'posthog-js/react';
import { useSearchParams } from '../../shared-components/useSearchParams';
import { useEffect, useCallback } from 'react';
import posthog from 'posthog-js';

const WEGLOT_SRC = 'https://cdn.weglot.com/weglot.min.js';

export const useWeglot = () => {
  const { params, updateParams } = useSearchParams();
  const langFF = useFeatureFlagPayload('integrated-language-translation')?.value;

  useEffect(() => {
    const script = document.querySelector(`script[src="${WEGLOT_SRC}"]`);
    if (!script) {
      console.warn('Weglot script tag not found in index.html');
      return;
    }

    const onLoad = () => {
      if (!window.Weglot.initialized) {
        window.Weglot.initialize({
          api_key: 'wg_a2ba8b2e281abc096c1790426f0419d13',
          hide_switcher: true,
          wait_transition: true,
        });
        document.documentElement.removeAttribute('translate');
      }
    };

    if (window.Weglot) {
      onLoad();
    } else {
      script.addEventListener('load', onLoad, { once: true });
      return () => script.removeEventListener('load', onLoad);
    }
  }, []);

  const switchLanguage = (lang) => {
    if (!window.Weglot?.initialized || !lang) return;
    window.Weglot.switchTo(lang);
    updateParams({ wgl: lang });
    posthog.register({ currentLanguage: lang });
  };

  useEffect(() => {
    if (!langFF) return;
    const initial = params.wgl || 'en';
    switchLanguage(initial);
  }, [langFF, params.wgl]);
};
